import React from "react";
import PropTypes from "prop-types";
import { Modal, Button, Spinner } from "react-bootstrap";

/**
 * UnsavedNumberModal asks the MIM what to do with an unsaved PRBT Problem
 * Number before leaving the page or switching tabs (US2138216). Dismissing it
 * (X, Escape, backdrop) is the same as Stay, so the edit is never discarded
 * without an explicit choice.
 */
function UnsavedNumberModal({ show, prbtNumber, newNumber, saving, onSave, onLeave, onStay, onExited }) {
  return (
    <Modal
      show={show}
      onHide={saving ? () => {} : onStay}
      onExited={onExited}
      centered
      data-testid="unsaved-number-modal"
    >
      <Modal.Header closeButton={!saving}>
        <Modal.Title>Problem Number not saved</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">
          <strong>{newNumber}</strong> has not been saved. If you continue without saving, this
          record will remain <strong>{prbtNumber}</strong>.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-secondary"
          onClick={onStay}
          disabled={saving}
          data-testid="unsaved-number-stay"
        >
          Stay
        </Button>
        <Button
          variant="outline-danger"
          onClick={onLeave}
          disabled={saving}
          data-testid="unsaved-number-leave"
        >
          Leave without saving
        </Button>
        <Button
          variant="primary"
          onClick={onSave}
          disabled={saving}
          data-testid="unsaved-number-save"
        >
          {saving ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
              Saving...
            </>
          ) : (
            "Save and continue"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

UnsavedNumberModal.propTypes = {
  show: PropTypes.bool.isRequired,
  prbtNumber: PropTypes.string,
  newNumber: PropTypes.string,
  saving: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onLeave: PropTypes.func.isRequired,
  onStay: PropTypes.func.isRequired,
  onExited: PropTypes.func,
};

export default UnsavedNumberModal;
